module.exports = __webpack_public_path__ + "img/1bc1eaf.jpg";